import { css, keyframes } from '@emotion/react'
import { memo } from 'react'
import { hexRGBA } from '../../../../../utilities/colors'
import { palette } from '../../../../styles/colors'

const rootStyles = css({
    position: 'relative',
    paddingLeft: 12,
    width: 72,
    margin: 8,
})

const bubble1Styles = css({
    position: 'absolute',
    top: 22,
    left: 9,
    height: 12,
    width: 12,
    borderRadius: '100%',
})

const bubble2Styles = css({
    position: 'absolute',
    height: 7,
    width: 7,
    left: 2,
    top: 32,
    borderRadius: '100%',
})

const bubble3Styles = css({
    borderRadius: 50,
    display: 'flex',
    height: '100%',
    width: '100%',
    padding: 14,
    bottom: 0,
    left: 0,
})

const bubbleMaskStyles = css({
    background: palette.background,
    position: 'relative',
    borderRadius: 50,
    height: '100%',
    width: '100%',
})

const blink = keyframes({
    '50%': {
        opacity: 1,
    },
})

const spanStyles = css({
    height: '7px',
    width: '7px',
    float: 'left' as const,
    margin: '0 2px',
    backgroundColor: palette.commonWhite,
    display: 'block',
    borderRadius: '50%',
    opacity: 0.25,
    '&:nth-of-type(1)': {
        animation: `1s ${blink} infinite 0.3333s`,
    },
    '&:nth-of-type(2)': {
        animation: `1s ${blink} infinite 0.6666s`,
    },
    '&:nth-of-type(3)': {
        animation: `1s ${blink} infinite 0.9999s`,
    },
})

type PMChatTypingIndicatorProps = {
    backgroundColor: string
    show: boolean
}

const PMChatTypingIndicator = memo((props: PMChatTypingIndicatorProps) => {
    const { backgroundColor: colorProp, show } = props
    const color = colorProp || '#333333'

    if (!show) {
        return null
    }

    const backgroundColor = hexRGBA(color, 0.1)
    const shadowColor = hexRGBA(color, 0.2)
    const boxShadow = `1px 1px 1px 0px ${shadowColor}`

    return (
        <div css={rootStyles} data-testid="Typing_Indicator">
            <div css={bubble1Styles} style={{ backgroundColor, boxShadow }} />
            <div css={bubbleMaskStyles}>
                <div css={bubble3Styles} style={{ backgroundColor, boxShadow }}>
                    <span css={spanStyles} style={{ backgroundColor: color }} />
                    <span css={spanStyles} style={{ backgroundColor: color }} />
                    <span css={spanStyles} style={{ backgroundColor: color }} />
                </div>
            </div>
            <div css={bubble2Styles} style={{ backgroundColor, boxShadow }} />
        </div>
    )
})

export default PMChatTypingIndicator
